/**
 * Do not edit directly
 * Generated on Thu, 27 Feb 2025 09:55:41 GMT
 */

export const BreakpointSmall = "768px";
export const BreakpointMedium = "1024px";
export const BreakpointLarge = "1280px";
export const BreakpointExtraLarge = "1680px";
export const ColorWhite = "#ffffff";
export const ColorBlack = "#000000";
export const ColorBase = "#242424";
export const ColorGrey100 = "#f8f6f1";
export const ColorGrey200 = "#f3efe7";
export const ColorGrey300 = "#e5e3e0";
export const ColorGrey400 = "#d0d0cd";
export const ColorGrey500 = "#929290";
export const ColorGrey600 = "#6b6a66";
export const ColorGrey700 = "#4d4d4c";
export const ColorGrey800 = "#333333";
export const ColorGrey900 = "#242424";
export const ColorGrey1000 = "#141414";
export const ColorRed100 = "#faeaec";
export const ColorRed200 = "#f0b7bf";
export const ColorRed300 = "#e88d97";
export const ColorRed400 = "#df6875";
export const ColorRed500 = "#d94a5b";
export const ColorRed600 = "#cf172c";
export const ColorRed700 = "#a51d2d";
export const ColorRed800 = "#720d19";
export const ColorRed900 = "#4e0910";
export const ColorRed1000 = "#2e050b";
export const ColorGreen100 = "#e7f9ee";
export const ColorGreen200 = "#a7d7ba";
export const ColorGreen300 = "#72c090";
export const ColorGreen400 = "#33a35e";
export const ColorGreen500 = "#1a994a";
export const ColorGreen600 = "#008031";
export const ColorGreen700 = "#006125";
export const ColorGreen800 = "#004d1d";
export const ColorGreen900 = "#003314";
export const ColorGreen1000 = "#00240e";
export const ColorBlue100 = "#e5f4fb";
export const ColorBlue200 = "#b1ddf2";
export const ColorBlue300 = "#73c3e7";
export const ColorBlue400 = "#32a6dc";
export const ColorBlue500 = "#0092d6";
export const ColorBlue600 = "#0070a3";
export const ColorBlue700 = "#005780";
export const ColorBlue800 = "#004261";
export const ColorBlue900 = "#00344d";
export const ColorBlue1000 = "#001c29";
export const ColorOrange100 = "#fceaca";
export const ColorOrange200 = "#fbdfb1";
export const ColorOrange300 = "#f7bf64";
export const ColorOrange400 = "#f5a732";
export const ColorOrange500 = "#f09400";
export const ColorOrange600 = "#db8700";
export const ColorOrange700 = "#c27400";
export const ColorOrange800 = "#a86800";
export const ColorOrange900 = "#613a00";
export const ColorOrange1000 = "#3d2500";
export const ColorPurple100 = "#efe7f9";
export const ColorPurple200 = "#decef2";
export const ColorPurple300 = "#ba9ae5";
export const ColorPurple400 = "#aa82de";
export const ColorPurple500 = "#996ad7";
export const ColorPurple600 = "#6d2ac6";
export const ColorPurple700 = "#5404be";
export const ColorPurple800 = "#4a03a0";
export const ColorPurple900 = "#3c0382";
export const ColorPurple1000 = "#270255";
export const ColorPink100 = "#fce8ef";
export const ColorPink200 = "#f7b6cc";
export const ColorPink300 = "#f075a0";
export const ColorPink400 = "#eb4c84";
export const ColorPink500 = "#ea3474";
export const ColorPink600 = "#d10062";
export const ColorPink700 = "#b80056";
export const ColorPink800 = "#8a0040";
export const ColorPink900 = "#5c002b";
export const ColorPink1000 = "#330016";
export const ColorTeal100 = "#e9f6f7";
export const ColorTeal200 = "#c7e8eb";
export const ColorTeal300 = "#8fd1d6";
export const ColorTeal400 = "#69c1c9";
export const ColorTeal500 = "#3ea0a8";
export const ColorTeal600 = "#2e7a7f";
export const ColorTeal700 = "#27696d";
export const ColorTeal800 = "#205356";
export const ColorTeal900 = "#173d3f";
export const ColorTeal1000 = "#122e30";
export const ColorNeutral100 = "#f8f6f1";
export const ColorNeutral200 = "#f3efe7";
export const ColorNeutral300 = "#e5e3e0";
export const ColorNeutral400 = "#d0d0cd";
export const ColorNeutral500 = "#929290";
export const ColorNeutral600 = "#6b6a66";
export const ColorNeutral700 = "#4d4d4c";
export const ColorNeutral800 = "#333333";
export const ColorNeutral900 = "#242424";
export const ColorNeutral1000 = "#141414";
export const ColorPrimary100 = "#e5f4fb";
export const ColorPrimary200 = "#b1ddf2";
export const ColorPrimary300 = "#73c3e7";
export const ColorPrimary400 = "#32a6dc";
export const ColorPrimary500 = "#0092d6";
export const ColorPrimary600 = "#0070a3";
export const ColorPrimary700 = "#005780";
export const ColorPrimary800 = "#004261";
export const ColorPrimary900 = "#00344d";
export const ColorPrimary1000 = "#001c29";
export const ColorSuccess100 = "#e7f9ee";
export const ColorSuccess200 = "#a7d7ba";
export const ColorSuccess300 = "#72c090";
export const ColorSuccess400 = "#33a35e";
export const ColorSuccess500 = "#1a994a";
export const ColorSuccess600 = "#008031";
export const ColorSuccess700 = "#006125";
export const ColorSuccess800 = "#004d1d";
export const ColorSuccess900 = "#003314";
export const ColorSuccess1000 = "#00240e";
export const ColorWarning100 = "#faeaec";
export const ColorWarning200 = "#f0b7bf";
export const ColorWarning300 = "#e88d97";
export const ColorWarning400 = "#df6875";
export const ColorWarning500 = "#d94a5b";
export const ColorWarning600 = "#cf172c";
export const ColorWarning700 = "#a51d2d";
export const ColorWarning800 = "#720d19";
export const ColorWarning900 = "#4e0910";
export const ColorWarning1000 = "#2e050b";
export const ElevationSurfaceSunkenBase = "#f8f6f1";
export const ElevationSurfaceDefaultBase = "#ffffff";
export const ElevationSurfaceDefaultHovered = "#f8f6f1";
export const ElevationSurfaceDefaultPressed = "#f3efe7";
export const ElevationSurfaceRaisedBase = "#ffffff";
export const ElevationSurfaceRaisedHovered = "#f8f6f1";
export const ElevationSurfaceRaisedPressed = "#f3efe7";
export const ElevationSurfaceOverlayBase = "#ffffff";
export const ElevationSurfaceOverlayHovered = "#f8f6f1";
export const ElevationSurfaceOverlayPressed = "#f3efe7";
export const ElevationShadowSunken = "none";
export const ElevationShadowDefault = "none";
export const ElevationShadowRaised = "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px 0 rgb(0 0 0 / 0.06)";
export const ElevationShadowOverlay = "0 6px 12px rgb(0 0 0 / 0.1), 0 4px 6px rgb(0 0 0 / 0.06), 0 0 1px rgb(0 0 0 / 0.15)";
export const ElevationBackdropColor = "#000000";
export const FocusRingColor = "#0092d6";
export const FocusRingOffset = "2rem";
export const FocusRingStyle = "solid";
export const FocusRingWidth = "3rem";
export const FontFamily = "'proxima-nova', Arial, sans-serif";
export const FontFamilySerif = "'caecilia', serif";
export const FontUrl = "'https://use.typekit.net/snp8vmp.css'";
export const IconSizeDefault = "1em";
export const IconSizeSmall = "12rem";
export const IconSizeMedium = "20rem";
export const IconSizeLarge = "24rem";
export const IconSizeLarger = "28rem";
export const IconSizeLargest = "32rem";
export const SpacingSpace0 = "0rem";
export const SpacingSpace25 = "2rem";
export const SpacingSpace50 = "4rem";
export const SpacingSpace75 = "6rem";
export const SpacingSpace100 = "8rem";
export const SpacingSpace150 = "12rem";
export const SpacingSpace200 = "16rem";
export const SpacingSpace250 = "20rem";
export const SpacingSpace300 = "24rem";
export const SpacingSpace400 = "32rem";
export const SpacingSpace500 = "40rem";
export const SpacingSpace600 = "48rem";
export const SpacingSpace800 = "64rem";
export const SpacingSpace1000 = "80rem";
export const TransitionDurationExtraFast = "0.1s";
export const TransitionDurationFast = "0.2s";
export const TransitionDurationNormal = "0.3s";
export const TransitionDurationSlow = "0.4s";
export const TransitionDurationExtraSlow = "0.5s";
export const TransitionFunctionEaseIn = "cubic-bezier(0.32, 0, 0.67, 0)";
export const TransitionFunctionEaseOut = "cubic-bezier(0.33, 1, 0.68, 1)";
export const TransitionFunctionEaseInOut = "cubic-bezier(0.65, 0, 0.35, 1)";
export const TypographyFontFamily = "Arial";
export const TypographyLabelSmallSize = "12rem";
export const TypographyLabelSmallLineHeight = 1.25;
export const TypographyLabelSmallWeight = 400;
export const TypographyLabelSmallTracking = 1;
export const TypographyLabelMediumSize = "14rem";
export const TypographyLabelMediumLineHeight = 1.25;
export const TypographyLabelMediumWeight = 400;
export const TypographyLabelMediumTracking = 1;
export const TypographyLabelLargeSize = "16rem";
export const TypographyLabelLargeLineHeight = 1.25;
export const TypographyLabelLargeWeight = 400;
export const TypographyLabelLargeTracking = 1;
export const TypographyBodySmallSize = "14rem";
export const TypographyBodySmallLineHeight = 1.65;
export const TypographyBodySmallWeight = 400;
export const TypographyBodySmallTracking = 1;
export const TypographyBodyMediumSize = "16rem";
export const TypographyBodyMediumLineHeight = 1.65;
export const TypographyBodyMediumWeight = 400;
export const TypographyBodyMediumTracking = 1;
export const TypographyBodyLargeSize = "20rem";
export const TypographyBodyLargeLineHeight = 1.65;
export const TypographyBodyLargeWeight = 400;
export const TypographyBodyLargeTracking = 1;
export const TypographyNavSmallSize = "14rem";
export const TypographyNavSmallLineHeight = 1.35;
export const TypographyNavSmallWeight = 400;
export const TypographyNavSmallTracking = 1;
export const TypographyNavMediumSize = "16rem";
export const TypographyNavMediumLineHeight = 1.35;
export const TypographyNavMediumWeight = 400;
export const TypographyNavMediumTracking = 1;
export const TypographyNavLargeSize = "18rem";
export const TypographyNavLargeLineHeight = 1.35;
export const TypographyNavLargeWeight = 400;
export const TypographyNavLargeTracking = 1;
export const TypographyHeadingSmallSize = "16rem";
export const TypographyHeadingSmallLineHeight = 1.35;
export const TypographyHeadingSmallWeight = 700;
export const TypographyHeadingSmallTracking = 1;
export const TypographyHeadingMediumSize = "18rem";
export const TypographyHeadingMediumLineHeight = 1.35;
export const TypographyHeadingMediumWeight = 700;
export const TypographyHeadingMediumTracking = 1;
export const TypographyHeadingLargeSize = "22rem";
export const TypographyHeadingLargeLineHeight = 1.35;
export const TypographyHeadingLargeWeight = 700;
export const TypographyHeadingLargeTracking = 1;
export const TypographyDisplaySmallSize = "28rem";
export const TypographyDisplaySmallLineHeight = 1.25;
export const TypographyDisplaySmallWeight = 700;
export const TypographyDisplaySmallTracking = 1;
export const TypographyDisplaySmallTabletSize = "24rem";
export const TypographyDisplayMediumSize = "34rem";
export const TypographyDisplayMediumLineHeight = 1.25;
export const TypographyDisplayMediumWeight = 700;
export const TypographyDisplayMediumTracking = 1;
export const TypographyDisplayMediumTabletSize = "26rem";
export const TypographyDisplayLargeSize = "48rem";
export const TypographyDisplayLargeLineHeight = 1.25;
export const TypographyDisplayLargeWeight = 700;
export const TypographyDisplayLargeTracking = 1;
export const TypographyDisplayLargeTabletSize = "34rem";